"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDepartInFromBookingTime = calculateDepartInFromBookingTime;
const constants_1 = require("@daytrip/constants");
const calculateNowInBookingTime_1 = require("./calculateNowInBookingTime");
function calculateDepartInFromBookingTime(bookingTime, originTimeZone, units) {
    const nowShifted = (0, calculateNowInBookingTime_1.calculateNowInBookingTime)(originTimeZone);
    const duration = bookingTime.getTime() - nowShifted;
    switch (units) {
        case "hours":
            return duration / constants_1.HOUR_IN_MILLISECONDS;
        case "minutes":
            return duration / constants_1.MINUTE_IN_MILLISECONDS;
        case "seconds":
            return duration / 1000;
        case "ms":
        default:
            return duration;
    }
}
//# sourceMappingURL=calculateDepartInFromBookingTime.js.map